import { acceptHMRUpdate, defineStore } from "pinia";
import { ref } from "vue";

import { useApi } from "@/services/api";

export const useFeaturesStore = defineStore("features", () => {
  const api = useApi();

  const emailInvitation = ref(false);
  const projectChat = ref(false);

  async function loadFeatures() {
    const features = await api.fetchFeatures({ reportErrors: false });
    if (features) {
      emailInvitation.value = features.smtp_email_enabled;
      projectChat.value = features.project_chat_enabled === true;
    }
  }

  return { emailInvitation, projectChat, loadFeatures };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFeaturesStore, import.meta.hot));
}
